<script setup lang="ts">
import HandleQueryStatus from "@/components/HandleQueryStatus.vue";
import StatsItem from "@/stats/StatsItem.vue";
import { DragHandGesture, EmojiTalkingHappy } from "@iconoir/vue";
import { useGetCanvassStats } from "./canvassesCrud";
import type { Canvass } from "./types";

const props = defineProps<{
  canvass: Canvass;
}>();

const { canvassStats, getCanvassStatsStatus } = useGetCanvassStats(
  props.canvass.id,
);
</script>

<template>
  <HandleQueryStatus :query-status="getCanvassStatsStatus">
    <section class="box">
      <h2>Aktion Highlights</h2>
      <div class="grid">
        <StatsItem>
          <template #header><DragHandGesture /> Türen geklopft</template>
          {{ canvassStats?.doorsKnocked }}
        </StatsItem>
        <StatsItem>
          <template #header><EmojiTalkingHappy /> Türen geöffnet</template>
          {{ canvassStats?.doorsOpened }}
        </StatsItem>
      </div>
    </section>
    <section
      v-if="
        canvassStats !== undefined &&
        canvassStats.canvassTargetsWithProgress.length > 0
      "
      class="box"
    >
      <h2>Definierte Gesprächsziele</h2>
      <div class="grid">
        <StatsItem
          v-for="canvassTarget in canvassStats.canvassTargetsWithProgress"
          :key="canvassTarget.id"
        >
          <template #header>{{ canvassTarget.description }}</template>
          {{ canvassTarget.satisfiedTargets }}/{{ canvassTarget.target }}
        </StatsItem>
      </div>
    </section>
  </HandleQueryStatus>
</template>
